import React from 'react'
import "./orderedItems.css"
import FoodType from '../../../../components/mini-components/mini-components'
import AddItems from "../../../../components/add-items/AddItems.jsx";
import {calculateOriginalPrice} from "../../../../functions/mini_func.js";

const OrderedItems = ({item , count , isLast}) => {
  console.log(item);
  return (
    <>
        <div className='ordered-list-container' >
            <FoodType/>
            <div className='ordered-food-items-info'>
                <h4>{item.name}</h4>
                <p>{"\u{20B9}\t"}{calculateOriginalPrice( item.discount  , parseFloat(item.price)  )*count}</p>
            </div>
           <AddItems item={item} />
        </div>
           {
             !isLast && <div className='dotted-border' ></div>

           }

    </>
  )
}

export default OrderedItems